import React from "react";

function Seat({
  cx,
  cy,
  r = 11.7,
  stroke = "#6D6D6D",
  strokeWidth = 1,
  fill = "white",
  label,
  fontSize = 15,
  labelColor = "red",
}) {
  return (
    <>
      {/* Ghế */}
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />

      {/* Số ghế */}
      <text
        x={cx}
        y={cy}
        fill={labelColor}
        textAnchor="middle"
        // dominantBaseline="middle"
        fontSize={fontSize}
        dy="0.3em" // fix lệch chữ
      >
        {label}
      </text>
    </>
  );
}

export default Seat;
